import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Tooltip } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Popover } from 'components/atoms/popover';
import { ActionFooter } from 'components/molecules/action-footer';
import { Popover as PopoverContent } from 'components/molecules/action-panel/popover';
import { DeleteButton } from 'components/organisms/timesheets/common/style';
import { getTotalMinutesForTask } from 'components/organisms/timesheets/common/utils';
import { TimesheetWeeklyRow } from '../types';

const Footer = styled(ActionFooter)`
  .ant-btn-link {
    color: var(--error-color);
  }
`;

interface Props {
  onDelete: () => void;
  record: TimesheetWeeklyRow;
}

export const DeleteRow: FC<Props> = ({ onDelete, record }) => {
  const totalMinutes = getTotalMinutesForTask(record.days);
  const [popoverVisible, setPopoverVisible] = useState(false);

  return totalMinutes === 0 ? (
    <Tooltip title={<FormattedMessage id="delete" />} placement="left">
      <DeleteButton
        icon={<TrashCan16 />}
        data-cy="buttons.delete-row"
        onClick={onDelete}
      />
    </Tooltip>
  ) : (
    <Popover
      trigger={['click']}
      placement="left"
      visible={popoverVisible}
      onVisibleChange={setPopoverVisible}
      content={
        <PopoverContent data-cy="popovers.delete-row-confirmation">
          <PopoverContent.Title>
            <FormattedMessage id="delete" />
          </PopoverContent.Title>
          <PopoverContent.Content>
            <FormattedMessage id="timesheets.delete_task.message" />
          </PopoverContent.Content>
          <PopoverContent.Divider />
          <Footer
            primary={{
              title: <FormattedMessage id="delete" />,
              onClick: () => {
                setPopoverVisible(false);
                onDelete();
              },
            }}
            other={[
              {
                title: <FormattedMessage id="cancel" />,
                onClick: () => {
                  setPopoverVisible(false);
                },
              },
            ]}
          />
        </PopoverContent>
      }
    >
      <Tooltip title={<FormattedMessage id="delete" />} placement="left">
        <DeleteButton
          icon={<TrashCan16 />}
          data-cy="buttons.delete-row-with-confirmation"
        />
      </Tooltip>
    </Popover>
  );
};
